import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = 'aqdlt 官方落地页 | aqdlt 核心服务平台';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'aqdlt 是您值得信赖的专业平台，提供全方位的 aqdlt 相关服务与解决方案。了解 aqdlt 的核心优势、功能特色与用户口碑，立即探索 aqdlt 带给您的全新体验与价值。'
      );
    }

    const existingScript = document.getElementById('home-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'home-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'aqdlt 官方首页',
      description: 'aqdlt 是您值得信赖的专业平台，提供全方位的 aqdlt 相关服务与解决方案。',
      url: 'https://aqdlt.com',
      isPartOf: {
        '@type': 'WebSite',
        name: 'aqdlt 官方平台',
        url: 'https://aqdlt.com',
      },
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('home-jsonld');
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}